import {InViewHookResponse} from "react-intersection-observer";

export type Section = {
    title: string,
    icon?: React.ReactNode,
    id: string,
    viewHook: InViewHookResponse,
};

export const getSectionFromList: (sections: Section[], id: string) => Section = (sections: Section[], id: string) => {
    const result = sections.find(section => section.id === id);
    if (result)
        return result;
    return {} as Section;
};

export const getSectionIndexFromList = (sections: Section[], id: string) => {
    return sections.findIndex(section => section.id === id);
}